import { useParams } from 'react-router-dom';
import { FundsTable, FundsSummary, BrokerTransactionsTable } from './components';
import { useFunds } from '@/context/FundsContext';
import { useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const FundsPage = (): React.ReactNode => {
  const { accountId } = useParams();
  const { transactions, refresh } = useFunds();

  useEffect(() => {
    if (!accountId) return;
    refresh(accountId);
  },[accountId, refresh]);

  return (
    <div className="flex flex-col gap-8">
      <FundsSummary />
      <Tabs defaultValue="transactions">
        <TabsList>
          <TabsTrigger value="transactions">Transactions</TabsTrigger>
          <TabsTrigger value="broker">Broker Transactions</TabsTrigger>
        </TabsList>
        <TabsContent value="transactions">
          <FundsTable transactions={transactions} />
        </TabsContent>
        <TabsContent value="broker">
          <BrokerTransactionsTable />
        </TabsContent>
      </Tabs>
    </div>
  );
};
